// src/components/chat/im.js
import TIM from 'tim-js-sdk'
import TIMUploadPlugin from 'tim-upload-plugin'

// 导出TIM对象供组件使用
export const TIM_NS = TIM // [!code ++]

export const initIM = (SDKAppID) => {
    const tim = TIM.create({
        SDKAppID,
        messageRoaming: true, // 开启消息漫游
        logLevel: 4, // 设置日志级别为1（INFO级别）
    })
    tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
    tim.on(TIM.EVENT.SDK_READY, () => {
        console.info('SDK ready')
    })
    tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function (event) {
        // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
        // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
        // event.data - 存储 Conversation 对象的数组 - [Conversation]
        console.log(event.data)
    })
    return tim
}

export const loginIM = async (tim, userID, userSig) => {
    return tim.login({ userID, userSig })
}
